import { render, staticRenderFns } from "./Distribution.vue?vue&type=template&id=280d00b4&scoped=true&lang=html"
import script from "./Distribution.vue?vue&type=script&lang=js"
export * from "./Distribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d00b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('280d00b4')) {
      api.createRecord('280d00b4', component.options)
    } else {
      api.reload('280d00b4', component.options)
    }
    module.hot.accept("./Distribution.vue?vue&type=template&id=280d00b4&scoped=true&lang=html", function () {
      api.rerender('280d00b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Distribution.vue"
export default component.exports